import ringsLogo from '~/assets/rings-logo.png';

export function getPlaceholderImage() {
  return ringsLogo;
}
